/* RESPONSIBLE TEAM: team-automation-foundations */

export function getOperatorName(appService: $TSFixMe): string {
  return appService.app.operatorBot?.name ?? '';
}

export function getOperatorAvatarUrl(appService: $TSFixMe): string | null {
  return appService.app.operatorBot?.avatar?.image_urls?.square_50 ?? null;
}
